import { render, staticRenderFns } from "./adminComments.vue?vue&type=template&id=e9ec701c&scoped=true&"
import script from "./adminComments.vue?vue&type=script&lang=js&"
export * from "./adminComments.vue?vue&type=script&lang=js&"
import style0 from "./adminComments.vue?vue&type=style&index=0&id=e9ec701c&lang=scss&scoped=true&"
import style1 from "./adminComments.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ec701c",
  null
  
)

export default component.exports